module.exports = __webpack_public_path__ + "img/63651d7.jpg";